export class CouponLeaguesRetriever {
    constructor(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;
        this.requestCouponLeagues = {};
        this.requestCouponLeagues.ids = this.dataProvider.leagueIds;
    }
    /* istanbul ignore next */
    setRegionIds(regionId) {
        // Not implemented
    }
    /* istanbul ignore next */
    removeRegionId() {
        // Not implemented
    }
    loadData() {
        this.bff.getLeaguesByLeagueId(this.requestCouponLeagues)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err); });
    }
    loadDataSuccessCb(response) {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}
//# sourceMappingURL=CouponLeaguesRetriever.js.map